<!-- =========================================================================================
  File Name: createTransfer.vue
  Description: Create Transfer component
  ----------------------------------------------------------------------------------------
  Author: Faruk Nikmorad
  Auth Date: 2020-10-14
========================================================================================== -->

<template>
  <div class="vx-row">
    <div class="vx-col w-1/1 md:w-1/2 w-full text-center">
      <h1> Welcome to Transfer Page </h1>
    </div>
    <div class="vx-col w-1/1 md:w-1/2 w-full">    
      <div class="w-full">
          <label class="vs-input--label">{{$t('Amount')}}</label>
        <vs-input class="w-full mb-4" @keypress="onlyForCurrency" @click="SelectAmount()" icon-pack="feather" icon="icon-dollar-sign" icon-no-border  v-model="requestTransaction.requestAmount"  ref="AmountAmount" />
        <div class="mb-4">
          <label class="vs-input--label">{{$t('FromAccount')}}</label>
          <v-select v-model="requestTransaction.account"  :reduce="item => item.value" :clearable="false" :options="getAccounts(requestTransaction.toAccount)" v-validate="'required'" name="account" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('account')">{{ errors.first('account') }}</span>
        </div>
        <div class="mb-4">
          <label class="vs-input--label">{{$t('ToAccount')}}</label>
          <v-select v-model="requestTransaction.toAccount"  :reduce="item => item.value" :clearable="false" :options="getAccounts(requestTransaction.account)" v-validate="'required'" name="toAccount" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          <span class="text-danger text-sm"  v-show="errors.has('toAccount')">{{ errors.first('toAccount') }}</span>
        </div>
          <label class="vs-input--label">{{$t('Description')}}</label>
        <vs-textarea class="w-full mb-4" v-model="requestTransaction.comment"/>
        <div class="vx-row">
            <div class="vx-col w-full">
              <vs-button
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-refresh-cw"
                @click="processRequestTransfer"
                >{{$t('Transfer')}}</vs-button>
            </div>
          </div>
      </div> 
    </div> 
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleTransactionMng from '@/store/transaction-mng/moduleTransactionMng.js'
import moduleMt4Management from '@/store/mt4-management/moduleMt4Management.js'
import vSelect from 'vue-select'
import Mgr from '@/services/SecurityService'
const user = new Mgr()

export default {
  props: {
    selectedItem : {
      type: Number,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  },
  data () {
    return {
      bankWireModel: {
        transferType: Boolean
      },
      userInfo: null,
      user: null,
      user_accounts: null,
      payload: {email: null, server: 'Real'},
      user_data: {},
      requestTransaction: {
        account: 0,
        amount: 0,
        currency: 1,
        status: 0,
        comment: '',
        note: '',
        product: 0,
        fee: 0,
        rate: 0,
        externalId: '',
        externalStatus: 0,
        ticket: 0,
        payerAmount: 0,
        requestAmount: 0,
        payerCurrency: 1,
        requestCurrency: 1,
        payerFee: 0,
        requestFee: 0,
        providerId: 0,
        providerMethodId: 0,
        walletDetail: '',
        data: {},
        wantBonus: false,
        toAccount: 0,
        customerId: -1
      }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    getSelectedData () {
      return this.data.find(item => {
        return item.id === this.selectedItem
      })
    },
    getAccounts () {
      return (filterValue) => {
        if (!this.user_accounts) return []
        return this.user_accounts.filter(f => f.LOGIN !== filterValue).map(d => ({
          label: `${d.Login  } - (L:${  d.Leverage  }) MF:(${  d.Margin_Free  })`,
          value: d.Login
        }))
      }
    }
  },
  methods: {

    GetProviderImg (ProviderImgName) {
      if (ProviderImgName === '') return ''
      return require(`@/assets/images/providers/${ProviderImgName}`)
    },
    
    onlyForCurrency ($event) {  
      this.requestTransaction.requestAmount = `${this.requestTransaction.requestAmount  }`
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || this.requestTransaction.requestAmount.indexOf('.') !== -1)) { // 46 is dot
        $event.preventDefault()
      }
      if (this.requestTransaction.requestAmount && this.requestTransaction.requestAmount.indexOf('.') > -1 && (this.requestTransaction.requestAmount.split('.')[1].length > 1)) {
        $event.preventDefault()
      }
    },

    SelectAmount () {
      this.$refs.AmountAmount.$refs.vsinput.select()
    },

    processRequestTransfer () {
      return new Promise((resolve, reject) => {
        this.requestTransaction.customerId = this.$store.state.AppActiveUser.customerId
        this.requestTransaction.Amount = this.requestTransaction.requestAmount
        this.requestTransaction.wantBonus = 0
        this.$store.dispatch('TransactionMng/addTransfer', this.requestTransaction)
          .then(res => { 

          if(res.data.isSuccess)
          {
            this.$vs.notify({
            title: 'Success',
            text: 'Has Been Successfully',
            color: 'success',
            iconPack: 'feather',
            icon: 'icon-check-circle'
            })
          }
          else
          {
            this.$vs.notify({
            title: 'Failed',
            text: res.data.data ,
            color: 'danger',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
            })
          }
            resolve(res)
          })
          .catch(err => {
            reject(`correct all values. ${  err}`)
          })
      })
    },
    getUserAccounts () {
      user.getUser()
        .then(u => {
          this.user = u
        })
      user.getProfile()
        .then(response => {
          this.userInfo = response
          if (this.userInfo) {
            this.payload.email = this.$store.state.AppActiveUser.email
            this.payload.server = 'Real'
            this.$store.dispatch('TransactionMng/fetchUserAccountsByEmail', this.payload)
              .then(res => { 
                this.user_accounts = res.data.data
              })
              .catch(err => {
                console.error(err) 
              })          
          }
        })
    }
  },

  created () {
    if (!moduleTransactionMng.isRegistered) {
      this.$store.registerModule('TransactionMng', moduleTransactionMng)
      moduleTransactionMng.isRegistered = true
    }

    if (!moduleMt4Management.isRegistered) {
      this.$store.registerModule('Mt4Management', moduleMt4Management)
      moduleMt4Management.isRegistered = true
    }

    this.getUserAccounts()
  }
}

</script>
